import { CALENDAR_MONTH, CHART_AREA, CHART_BAR, CHART_DONUT, CHART_LINE, GRID_3X3, NUM_123, PROGRESS, TABLE } from '../icons';

/**
 * The glyph beside a chart's form on the Reports list (plan §6.1: "the name,
 * the card's RecordBadge, a form glyph, the tier, and the updated line"). Each
 * is a registry icon already, so nothing is added to the icon library.
 */
const FORM_GLYPHS = Object.freeze({
	number: NUM_123,
	progress: PROGRESS,
	bar: CHART_BAR,
	line: CHART_LINE,
	area: CHART_AREA,
	donut: CHART_DONUT,
	heatmap: GRID_3X3,
	calendar: CALENDAR_MONTH,
	table: TABLE,
});

/** The glyph for a form, the bar chart's for one this build does not know. */
export function chartFormGlyph(form) {
	return typeof form === 'string' && Object.prototype.hasOwnProperty.call(FORM_GLYPHS, form) ? FORM_GLYPHS[form] : CHART_BAR;
}
